<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>The Killing Ship</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<h1 class="TI_Title_page_title">THE KILLING SHIP</h1>
<h2 class="AU_Author_names">Simon Beaufort</h2>
<p> </p>
<p> </p>
<p class="LOGO_Colophon_or_logo"><img alt="logo missing" height="51" src="images/logo.jpg" width="72"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?bf859bd0